import React from 'react';
import type { ElementType, FC, PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';

type FormLabelVisuallyHiddenProps = {
  component: ElementType;
};

const StyledFormLabelVisuallyHidden = styled(FormLabel)({
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  border: '0',
}) as typeof FormLabel;

const FormLabelVisuallyHidden: FC<
  PropsWithChildren<FormLabelVisuallyHiddenProps>
> = ({ children, component }) => {
  return (
    <StyledFormLabelVisuallyHidden component={component}>
      {children}
    </StyledFormLabelVisuallyHidden>
  );
};

export default FormLabelVisuallyHidden;
